import * as React from "react"
import { api, ApiError, type SessionUser } from "./api"

export function useSession() {
  const [user, setUser] = React.useState<SessionUser | null | undefined>(undefined)

  React.useEffect(() => {
    let cancelled = false
    api<SessionUser>("/api/session")
      .then((u) => { if (!cancelled) setUser(u) })
      .catch((err) => {
        if (cancelled) return
        if (err instanceof ApiError && err.status === 401) setUser(null)
        else setUser(null)
      })
    return () => { cancelled = true }
  }, [])

  return user
}
